export default __webpack_public_path__ + "static/media/certificate.686df2a1.svg";